// @flow
import axios from "axios";
import { enqueueSnackbar } from "notistack";
import React, { useCallback } from 'react';
import {useTranslation} from "react-i18next";
import { API } from "../../../../../helpers/constants";
import { handleAxiosErrors } from "../../../../../helpers/errorHandling";
import useUserData from "../../../../../hooks/user/useUserData";
import {EXHIBITION} from "../../../../../locales/components/namespaces";
import {ListSubheader, TextField} from "@mui/material";
import ListItem from "@mui/material/ListItem";
import {getRouteUrl} from "../../../../../helpers/getRouteUrl";
import {
	ROUTE_PAGE_EXHIBITION_QUICK_BADGE,
	ROUTE_PAGE_EXHIBITION_SETTINGS_BADGE_CUSTOMIZE
} from "../../../../../routers/routes";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import { Link, useHistory } from "react-router-dom";
import Divider from "@mui/material/Divider";
import {NumericFormat} from "react-number-format";
import {Update} from "../../../../../hooks/exhibitions/useExhibitionAction";
import {useDebouncedCallback} from "../../../../../hooks/useDebouncedCallback";
import Typography from "@mui/material/Typography";
import {normalizeGreek} from "../../../../../helpers/normalizeGreek";
import ImageByLanguage from "../generalExhibitionSettings/components/imageByLanguage";

type Props = {};

const BadgeSettings = (props: Props) => {
	const {id, updateExhibition, exhibition} = props
	const {t} = useTranslation(EXHIBITION)
	const {token} = useUserData()
	const onChangeValidQrDays = (value) => {
		updateExhibition(id, value, Update.ValidQrDays)
	}
	const {
		value: validQrDays,
		debouncedOnChange: debouncedOnChangeValidQrDays
	} = useDebouncedCallback(onChangeValidQrDays, exhibition.validQrDays)
	const onRemoveBadgeLogo = useCallback((language) => {
		axios({
			method: 'POST',
			headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
			url: `${API}/en/exhibition/deletebadgelogo/${id}`,
			data: {
				language: language?.toUpperCase()
			}
		}).then(response => {
			enqueueSnackbar(t('Badge logo removed successfully!'), {
				variant: 'success',
			})
		}).catch(error => {
			enqueueSnackbar(handleAxiosErrors(error, t('Failed to remove badge logo!')), {
				variant: 'error',
			})
		})
	}, [id, t, token])
	return (
		<List
			subheader={<ListSubheader sx={{backgroundColor: '#F9FBF2'}}><Typography variant={'button'}
																					sx={{color: '#000000', textTransform: 'uppercase'}}>{normalizeGreek(t('Badge'))}</Typography></ListSubheader>}
			sx={{mb: 1, pb: 0, width: '100%', bgcolor: 'background.paper', border: '1px solid #8c9eff'}}
		>
			<ListItem
				component={Link}
				to={getRouteUrl(ROUTE_PAGE_EXHIBITION_SETTINGS_BADGE_CUSTOMIZE, {id}, {section: "design-and-print-settings"})}
			>
				<ListItemText primary={t("Customize, Visitor Categories And Special Rules")}/>
			</ListItem>
			<Divider component="li"/>
			<ListItem
				component={Link}
				to={getRouteUrl(ROUTE_PAGE_EXHIBITION_QUICK_BADGE, {id: id})}
			>
				<ListItemText primary={t("Quick Print Badge")}/>
			</ListItem>
			<Divider component="li"/>
			<ListItem>
				<ListItemText
					primary={t("Visitors QR Validity Period After Exhibition")}
					secondary={t('If set, visitors will be able to visit other exhibitions, by using their QR code of this exhibition. QR code will be valid for upcoming exhibitions within the days limit you set after this exhibition.')}
				/>
				<NumericFormat
					defaultValue={validQrDays}
					onChange={debouncedOnChangeValidQrDays}
					variant={'filled'}
					slotProps={{
						htmlInput: {
							maxLength: 3
						}
					}}
					required
					thousandSeparator={''}
					decimalScale={0}
					allowNegative={false}
					customInput={TextField}
					size={'small'}
					allowLeadingZeros={true}
				/>
			</ListItem>
			<Divider component="li"/>
				<ImageByLanguage
					name={'logo'}
					label={t('Badge Logo')}
					updateProperty={'badgeImage'}
					updateType={Update.BadgeLogo}
					language={"el"}
					id={id}
					exhibition={exhibition}
					updateExhibition={updateExhibition}
					onRemove={onRemoveBadgeLogo}
				/>
			<Divider component="li"/>
				<ImageByLanguage
					name={'logo'}
					label={t('Badge Logo')}
					updateProperty={'badgeImage'}
					updateType={Update.BadgeLogo}
					language={"en"}
					id={id}
					exhibition={exhibition}
					updateExhibition={updateExhibition}
					onRemove={onRemoveBadgeLogo}
				/>
		
		</List>
	);
};

export default BadgeSettings